/*
 * Recruiter-facing display copy for applications.stage. The stored value is a stable token;
 * rewording here is not a schema change. Note this is the RECRUITER vocabulary — candidates see
 * the collapsed set from @velaigal/shared's candidateStage(), which never discloses shortlisted
 * or first_viewed_at.
 */
export const STAGE_LABEL: Record<string, string> = {
  submitted: 'Submitted',
  under_review: 'Under review',
  shortlisted: 'Shortlisted',
  interviewing: 'Interviewing',
  hired: 'Hired',
  rejected: 'Not selected',
  withdrawn: 'Withdrawn',
};

export function stageLabel(stage: string): string {
  return STAGE_LABEL[stage] ?? stage;
}

/*
 * `first_viewed_at IS NULL` is what the old auto-flip to under_review was really being used to
 * say — and unlike the flip it is accurate, idempotent, and consumes no stage transition. Once
 * someone has opened the candidate there is nothing to announce.
 */
export function viewedLabel(firstViewedAt: string | null): string | null {
  return firstViewedAt === null ? 'Not opened yet' : null;
}
